module.exports = __webpack_public_path__ + "images/stickers/frown.49afc75f79a5719a3871.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/frown.png
// module id = 21if
// module chunks = 12